export interface InitData {
  categories: ProductCategory[];
  special_offers: CustomersProduct[];
  stores: Store[];
  tags: string[];
}

export interface SearchResultMeta {
  total: number;
  page_size: number;
  p: number;
}

export interface SearchResult {
  data: CustomersProduct[];
  meta: SearchResultMeta;
}

export interface SuggestionForm {
  name: string;
  email: string;
  location: string;
  message: string;
}

export interface InterestForm {
  contact_name: string;
  company_name: string;
  email: string;
  trade_type: "Direktvertrieb" | "Händler";
  number_of_products: number;
  product_categories: string;
  desired_start_date: Date;
  location: string;
  self_delivery: boolean;
  remarks: string;
}

export type MunicipalitiesInterestForm = {
  location: string;
  postal_code: string; // 5-stellige PLZ
  population: number;
  contact_name: string;
  contact_role: string;
  email: string;
  phone?: string | null;
  local_supplies: LocalSupplies[];
  kms_next_supply?: string | null;
  motivation: Motivation[];
  motivation_text?: string | null;
  sales_area_available: boolean;
  sales_area_location?: string | null;
  project_start: ProjectStart;
  partner_talks: PartnerTalks;
  partner_talks_text?: string | null;
  concrete_wish?: string | null;
};

// --- UI domain types & options for Municipality interest (front-end only) ---
export type LocalSupplies =
  | "Bäcker"
  | "Metzger"
  | "Gemüseladen"
  | "Lebensmittelladen"
  | "Supermarkt"
  | "Keine";

export type Motivation =
  | "Nahversorgung sichern"
  | "Ortsmitte stärken"
  | "Ältere Menschen versorgen"
  | "Regionalität fördern"
  | "Digitale Lösung gesucht"
  | "Sonstiges";

export type ProjectStart = "Sofort" | "Innerhalb von 3 Monaten" | "Später" | "Noch offen";
export type PartnerTalks = "Ja" | "Nein" | "Sonstiges";

export const LOCAL_SUPPLIES_OPTIONS: LocalSupplies[] = [
  "Bäcker",
  "Metzger",
  "Gemüseladen",
  "Lebensmittelladen",
  "Supermarkt",
  "Keine",
];

export const MOTIVATION_OPTIONS: Motivation[] = [
  "Nahversorgung sichern",
  "Ortsmitte stärken",
  "Ältere Menschen versorgen",
  "Regionalität fördern",
  "Digitale Lösung gesucht",
  "Sonstiges",
];

export const PROJECT_START_OPTIONS: ProjectStart[] = [
  "Sofort",
  "Innerhalb von 3 Monaten",
  "Später",
  "Noch offen",
];

export const PARTNER_TALKS_OPTIONS: PartnerTalks[] = ["Ja", "Nein", "Sonstiges"];
// --- end municipality UI domain ---

// "Support" goes to support@, everything else to info@ (api: ContactConcern).
export type ContactConcern = "Support" | "Allgemeine Anfrage";

export interface ContactFormData {
  name: string;
  email: string;
  subject: string;
  message: string;
  concern: ContactConcern | "";
}

export interface CustomersCampaign {
  id: number;
  tag: string;
  icon: string;
  title: string;
  subtitle: string;
  image_url: string;
}

export interface CustomersMarket {
  id: number;
  name: string;
}

export interface CustomersBaseModel {
  id: number;
  name: string;
}

export interface CustomersAvailability {
  store: CustomersBaseModel;
  amount: number;
}

export interface CustomersProduct {
  id: number;
  name: string;
  description: string;
  producer?: string;
  vendor: string;
  category?: CustomersBaseModel;
  uom: string;
  content_qty: number;
  list_price: number;
  reduced_price: number;
  discount_start_date?: string | null;
  discount_end_date?: string | null;
  tags: string[];
  image_url?: string | null;
  availabilities: CustomersAvailability[]
}

export interface ProductCategory {
  id: number,
  name: string
}

export interface Store {
  id: number;
  name: string;
  street: string;
  city: string;
  zip: string;
  latitude: number;
  longitude: number;
  openingHours?: string;
}

export type SupplyAnswer = 'Ja' | 'Nein' | 'Nach Absprache';

export interface CustomerFeedbackForm {
  store: string;
  cleanliness: number | null;
  tidiness: number | null;
  availability: number | null;
  assortment: number | null;
  message: string;
  email: string;
}

export interface SupplierOfferForm {
  company_name: string;
  contact_name: string;
  email: string;
  phone: string;
  website: string;
  location: string;
  products: string;
  delivery_area: string;
  delivery_schedule: string;
  self_delivery: SupplyAnswer | '';
  self_stocking: SupplyAnswer | '';
  remarks: string;
}

export interface SupplierRecommendationForm {
  store: string;
  supplier_name: string;
  supplier_location: string;
  products: string;
  website: string;
  reason: string;
  email: string;
}
